import React, { Component } from 'react';
import { RouteProps } from 'react-router';

export class Kvkk extends Component<any> {
    public render() {
        return (
            <div>
                Kişisel Verilerin Korunması Kanunu (KVKK) Bilgilendirme Yazısı
Sayın Vakıf Dostumuz,

Türkiye Spastik Çocuklar Vakfı (Vakıf) olarak kişisel verilerinizin güvenliği konusunda hassasiyet göstermekteyiz. Bu bilinçle, Vakıf olarak hizmetlerimizden faydalanan kişiler dahil, Vakfımıza destek veren bağışçılarımızın, gönüllülerimizin ve tüm paydaşlarımızın, Vakıf ile ilişkili tüm şahısların her türlü kişisel verilerinin 07.04.2016 tarihinde yayınlanarak yürürlüğe giren 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVK Kanunu) kapsamına uygun işlenmesi, muhafaza edilmesi ve korunmasına büyük önem veriyoruz.

Siz değerli bağışçılarımız, gönüllülerimiz ve paydaşlarımız kişisel verilerinizi birçok kanaldan Vakfımız ile paylaşabiliyorsunuz. Paylaşmış olduğunuz kişisel verileriniz işbu Kanun kapsamında Vakfımız tarafından muhafaza edilip, vermiş olduğunuz onay çerçevesinde işlenecektir. Vakfımıza ilişkin tanıtım, teşekkür, bilgilendirme ve duyuru amaçlı iletişimleri gerçekleştirmek; istatistiki bilgi toplamak ve derlemek; bağış, gönüllülük, eğitim ve savunuculuk çalışmalarını geliştirmek amaçlarıyla kişisel verileriniz tarafımızca kullanılabilecektir.

Bu sorumluluğumuzun tam idraki ile KVK Kanunu’nda tanımlı şekli ile “Veri Sorumlusu” sıfatıyla, kişisel verilerinizi aşağıda yer alan mevzuattaki sınırlar çerçevesinde işlemekte olduğumuzu bilgilerinize sunarız.kvkk yazılar sayfasi
            </div>
        );
    }
}

export default Kvkk;
